import PhoneIcon from "@mui/icons-material/PhoneIphone";
import { Tooltip, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.swaRed,
    fontSize: "30px",
  },
  toolTip: {
    maxWidth: "200px",
    fontSize: "12px",
  },
}));

const StarsPhoneIcon = (props) => {
  const classes = useStyles();

  return props.toolTipMessage ? (
    <Tooltip
      title={
        <React.Fragment>
          <Typography color="inherit" fontSize="14px" fontWeight="bold">
            {props.toolTipHeader}
          </Typography>
          {props.toolTipMessage}
        </React.Fragment>
      }
      arrow
      placement="right"
      classes={{ tooltip: classes.toolTip }}
    >
      <PhoneIcon className={classes.icon} />
    </Tooltip>
  ) : (
    <PhoneIcon className={classes.icon} />
  );
};

StarsPhoneIcon.propTypes = {
  toolTipHeader: PropTypes.string,
  toolTipMessage: PropTypes.string,
};

export default StarsPhoneIcon;
